module.exports = __webpack_public_path__ + "static/cercazone_hero5-871b5e43bef71573c3df7ea3dc67b24d.jpg";